import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortalRoutingModule } from './portal-routing.module';

import { SharedModule } from '../common/shared.module';
import { FormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ChartistModule } from 'ng-chartist';
import { PortalHomeComponent } from './home/portal-home.component';
import { PortalQuoteComponent } from './quote/portal-quote.component';
import { PortalPolicyComponent } from './policy/portal-policy.component';
import { PortalOfferNewComponent } from './offer/new/portal-offer-new.component';
import { OfferCommonModule } from '../offer/offer-common.module';
import { PortalOfferComponent } from './offer/portal-offer.component';
import { PortalPaymentComponent } from './payment/portal-payment.component';
import { PortalLoginComponent } from './login/portal-login.component';
import { PortalRegisterComponent } from './register/portal-register.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PortalCommonModule } from './portal-common.module';
import { PortalPasswordComponent } from './password/portal-password.component';

@NgModule({
    declarations: [
        PortalHomeComponent,
        PortalQuoteComponent,
        PortalPolicyComponent,
        PortalOfferNewComponent,
        PortalOfferComponent,
        PortalPaymentComponent,
        PortalLoginComponent,
        PortalRegisterComponent,
        PortalPasswordComponent
    ],
    imports: [
    CommonModule,
    PortalRoutingModule,
    SharedModule,
    FormsModule,
    NgxSpinnerModule,
    ChartistModule,
    OfferCommonModule,
    NgbModule,
    PortalCommonModule
  ]
})
export class PortalModule { }
